export {
    CheckBox,
    CheckBox as default,
    EllipsisTypes,
} from './checkbox.component';

export {default as CheckboxSvg} from './svg';

export type {
    CheckBoxProps,
    CheckBoxProps as Props,
} from './checkbox.component';
